import React from 'react';
import { Link } from 'react-router-dom'
import './PrivacyPolicy.css';
import logComponent from '../../common/logComponent';

export default function PrivacyPolicy() {

  if (logComponent('PrivacyPolicy')) { console.debug('PrivacyPolicy rendered'); }

  return (
    <Link to='../privacy'
      target='_blank'>
      Privacy Policy
    </Link>
  )
}
